import type { ActionReducerMap } from '@ngrx/store';

import {
  fehAddressCheckKey,
  fehAddressCheckReducer,
  type FehAddressCheckState,
} from './feh-address-check.service/feh-address-check.reducer';

export const fehServicesStoreSelectorKey = 'feh-services';

export interface FehServicesState {
  readonly [fehAddressCheckKey]: FehAddressCheckState;
}

export const reducers: ActionReducerMap<FehServicesState> = {
  [fehAddressCheckKey]: fehAddressCheckReducer,
};
